
/* ----- Middlewares ----- */
import caAuth from "@/middleware/caAuth";
import caGuest from "@/middleware/caGuest";

/* ----- Routes ----- */
import clientsAreaRoutes from "@/router/routes/clients-area-routes";

/* ----- Layout ----- */
import ClientsAreaAuth from "@/pages/ClientsArea/Auth/ClientsAreaAuth";
import ClientsAreaLayout from "@/pages/ClientsArea/ClientsAreaLayout";

/* ----- Views ----- */
import ClientsAreaLogin from "@/pages/ClientsArea/Auth/ClientsAreaLogin";
import InterventionValidation from "@/pages/Planning/Intervention/validation/InterventionValidation";

/* ----- ----- ----- ----- ----- ----- ----- */

const clientsAreaPublicRoutes = [
    {
        path: "login",
        name: "caLogin",
        component: ClientsAreaLogin,
        meta: {}
    },
].map(route => {
    return {...route, meta: { ...route.meta, middleware: caGuest }}
})

const clientsAreaAuthRoutes = [
    ...clientsAreaRoutes
].map(route => {
    return {...route, meta: { ...route.meta, middleware: caAuth }}
})

const routes = [
    {
        path: "/",
        redirect: "/dashboard",
    },
    {
        path: '/',
        component: ClientsAreaAuth,
        meta: { middleware: caGuest },
        children: clientsAreaPublicRoutes
    },
    {
        path: '/',
        component: ClientsAreaLayout,
        meta: { middleware: caAuth },
        children: clientsAreaAuthRoutes
    },
    {
        path: "/intervention_validation",
        component: InterventionValidation,
    },
]
export default routes